var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import ListCell from '@doordash/component-list-cell';
import Popover from '@doordash/component-popover';
import { Colors, Icon, InlineChildren, Spacing, } from '@doordash/design-language';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { useTeamAccountSelector } from './hook';
import { selectTeamAccount } from '../Ui/ui_slice';
import { AdminPageSidebarTestId } from '../testId';
var TeamAccountDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  margin-top: ", "px;\n  border-bottom: ", "px solid ", ";\n  & div {\n    vertical-align: bottom;\n  }\n  & #TeamAccounInlineChildrenContainer > div > div > div {\n    height: 24px;\n  }\n"], ["\n  background-color: ", ";\n  margin-top: ", "px;\n  border-bottom: ", "px solid ", ";\n  & div {\n    vertical-align: bottom;\n  }\n  & #TeamAccounInlineChildrenContainer > div > div > div {\n    height: 24px;\n  }\n"])), Colors.BackgroundPrimary, Spacing.XxLarge, Spacing.XxxxSmall, Colors.SystemGrey5);
var ListCellContainer = styled(ListCell)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var InlineChildrenContainer = styled(InlineChildren)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var PopoverContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  min-width: 400px;\n  overflow-y: auto;\n  max-height: 560px; // each cell is 56px, this should show 10 cells before scrolling\n"], ["\n  min-width: 400px;\n  overflow-y: auto;\n  max-height: 560px; // each cell is 56px, this should show 10 cells before scrolling\n"])));
export var PopoverContent = function (_a) {
    var onClick = _a.onClick, selectedTeamAccountId = _a.selectedTeamAccountId, dropdownOptions = _a.dropdownOptions;
    return (React.createElement(PopoverContainer, { role: "radiogroup" }, dropdownOptions.map(function (_a) {
        var value = _a.value, name = _a.name;
        var isSelected = value === selectedTeamAccountId;
        return (React.createElement(ListCellContainer, { isToggleable: true, isSeparatorVisible: true, isToggled: isSelected, onClick: function () {
                onClick(value);
            }, title: name, key: value, renderAfterContent: function () {
                return isSelected ? (React.createElement(Icon, { accessibilityLabel: '', type: Icon.Types.Check, size: Icon.Sizes.Medium })) : null;
            } }));
    })));
};
export var TeamAccountSelector = function (_a) {
    var shouldRender = _a.shouldRender;
    var listCellRef = React.useRef(null);
    var _b = __read(React.useState(false), 2), isPopoverVisible = _b[0], setIsPopoverVisible = _b[1];
    var dismissPopover = React.useCallback(function (event) {
        var _a;
        if (!((_a = listCellRef === null || listCellRef === void 0 ? void 0 : listCellRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            setIsPopoverVisible(false);
        }
    }, [setIsPopoverVisible]);
    React.useEffect(function () {
        document.addEventListener('click', dismissPopover);
        return function () {
            document.removeEventListener('click', dismissPopover);
        };
    }, [dismissPopover]);
    var teamAccountSelectorOptions = useTeamAccountSelector();
    var selectedTeamAccountName = teamAccountSelectorOptions.selectedTeamAccountName, selectedTeamAccountId = teamAccountSelectorOptions.selectedTeamAccountId, dropdownOptions = teamAccountSelectorOptions.dropdownOptions;
    var dispatch = useDispatch();
    var onClickPopover = React.useCallback(function (teamId) {
        dispatch(selectTeamAccount(teamId));
        setIsPopoverVisible(false);
    }, [dispatch, setIsPopoverVisible]);
    if (!shouldRender) {
        return null;
    }
    return (React.createElement(TeamAccountDiv, null,
        React.createElement(Popover, { position: Popover.Positions.BottomLeft, showContainerPointer: false, isVisible: isPopoverVisible, interactionType: Popover.InteractionTypes.Controlled, content: React.createElement(PopoverContent, { dropdownOptions: dropdownOptions, onClick: onClickPopover, selectedTeamAccountId: selectedTeamAccountId }) }, function (_a) {
            var describeBy = _a.describeBy;
            return (React.createElement("div", { ref: listCellRef },
                React.createElement(InlineChildrenContainer, { id: "TeamAccounInlineChildrenContainer", onClick: function () { return setIsPopoverVisible(!isPopoverVisible); }, "data-testid": AdminPageSidebarTestId.TeamAccountSelector },
                    React.createElement(ListCell, { isToggleable: true, accessibilityDescribedBy: describeBy, isSeparatorVisible: false, renderBeforeContent: function () { return (React.createElement(Icon, { type: Icon.Types.ChevronDown, size: Icon.Sizes.Medium })); }, title: selectedTeamAccountName }))));
        })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
